import { RouteObject } from 'react-router-dom'
import { PageLayout } from '$components/common'
import { default as Payroll } from '.'

const basePath = '/time/payroll'
export const payrollRoutes: RouteObject[] = [
  {
    path: `${basePath}/pay-summary`,
    element: (
      <PageLayout title={'Pay Summary'} displayDateFilter={true}>
        <Payroll.PaySummary.Component />
      </PageLayout>
    ),
    loader: Payroll.PaySummary.Loader,
  },
  {
    path: `${basePath}/pay-runs`,
    element: (
      <PageLayout title={'Pay Runs'} displayLeftTitle={false}>
        <Payroll.PayRuns.Component />
      </PageLayout>
    ),
    loader: Payroll.PayRuns.Loader,
  },
  {
    path: `${basePath}/pay-runs/:payRunId`,
    element: (
      <PageLayout title={'Edit Pay Run'} displayLeftTitle={false}>
        <Payroll.PayRuns.Edit.Component />
      </PageLayout>
    ),
    loader: Payroll.PayRuns.Edit.Loader,
  },
]
